import { Injectable } from "@angular/core";
import * as _ from 'lodash';
import { Consommable } from "src/app/domain/consommable";
import { mapper } from "src/app/tools/mapping/mapper";
import { db } from "../db";
import { ConsommableEntity } from "../consommable.entity";
import { PrelevementEntity } from "../prelevement.entity";

@Injectable({
    providedIn: 'root',
})
export class ConsommableRepository {
    constructor() { }

    async getConsommableById(id: number) {

        return await db.consommables.where('Id').equals(id).first(async ze => {
            const z = mapper.map(ze, ConsommableEntity, Consommable);
            return z;
        });
    }

    async getConsommableEntityById(id: number) {
        return await db.consommables.where('Id').equals(id).first(async ze => {
            return ze;
        });
    }

    async attachConsommable(consommable: Consommable, prel: PrelevementEntity) {
        let conId: number;
        const oe = mapper.map(consommable, Consommable, ConsommableEntity);

        // const ae = await this.prelevementRepository.getPrelevementEntityByCode(prelCode);
        conId = await db.consommables.add(oe);
        prel.ConsommableIds = prel?.ConsommableIds ? [...prel.ConsommableIds, conId] : [conId]
        if (prel && prel.Id) {
            await db.prelevements.update(prel.Id, {
                ConsommableIds: prel?.ConsommableIds
            });
        }
        return conId;
    }

    async deleteConsommableById(id: number, prel: PrelevementEntity) {
        await db.consommables.where('Id').equals(id).delete();

        // const oe = await this.prelevementRepository.getPrelevementEntityByCode(prel.Code);
        if (prel && prel.Id) {
            _.remove(prel.ConsommableIds, x => x === id)
            await db.prelevements.update(prel.Id, {
                ConsommableIds: prel.ConsommableIds
            });
        }
    }

    async deleteConsommableByNumeroLot(prel: PrelevementEntity) {
        // await db.consommables.delete()
        for (let c = 0; c < prel?.ConsommableIds?.length!; c++) {
            await db.consommables.where('Id').equals(prel.ConsommableIds[c]).delete();

            if (prel && prel.Id) {
                _.remove(prel.ConsommableIds, x => x === prel.ConsommableIds[c])
                await db.prelevements.update(prel.Id, {
                    ConsommableIds: prel.ConsommableIds
                });
            }
        }
    }
}